import changePassword from '@/components/OpenCall/changePassword/changePassword.vue'
import alerts from '@/components/Alert/Alert.vue'
import modalNewEdition from '@/components/Manager/newEdition/newEdition.vue';
import modalConfirm from '@/components/Tools/Confirm/Confirm.vue';

export default {
  name: 'Config',

  components: {
    changePassword,
    alerts,
    modalNewEdition,
    modalConfirm
  },

  data() {
    return {

      modal_changePassword: false,
      modal_newEdition: false,

      edition_view: false,

      modal_confirm: {
        status: false,
        title: "",
        text: "",
        question: "",
        callback: ""
      },

      alert_temp: {
        status: false,
        label: "",
        type: ""
      },

      dConfig: {
        name: "",
        email: ""
      },

      dEdition: {
        edition: ""
      },

      items: [
        {
          'id': '1',
          'title': 'hello',
          'description': 'ok ok',
          'created_date': '2018-09-09'
        },
        {
          'id': '2',
          'title': 'hello 2',
          'description': 'ok ok 2',
          'created_date': '2018-10-09'
        }
      ],
      columns: ['id', 'title', 'description', 'created_date']

    }
  },
  methods: {
    saveChanges(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {

          if (this.dConfig.email == '' && this.dConfig.name == '') {
            /** Alert */
            this.alert_temp = {
              status: true,
              type: "warning",
              label: 'Faltan Datos.'
            }; setTimeout(() => { this.alert_temp.status = false; }, 3000);
            /** FIN Alerta */
            // alert('Faltan Datos.');
            return;
          }

          (async () => {

            var data = JSON.parse(JSON.stringify(this.dConfig));
            data._id = this.$session.get('_id');

            await fetch('https://api.salonacme.com/manager/changeConfig', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            }).then(async response => {
              response = await response.json();
              if (response.status) {
                // console.log(response);
                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "success",
                  label: response.msg
                }; setTimeout(() => {
                  this.alert_temp.status = false;

                }, 3000);
                /** FIN Alerta */

                // alert(response.msg);

                this.$session.set('name', this.dConfig.name);
                this.$session.set('email', this.dConfig.email);

                if (this.$session.get('type') == 'admin')
                  this.$router.push('/opencall_admin');
                else
                  this.$router.push('/opencall');

                setTimeout(() => {
                  location.reload(true);
                }, 500);


              } else {

                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "warning",
                  label: response.msg
                };
                setTimeout(() => { this.alert_temp.status = false; }, 3000);
                /** FIN Alerta */

                // alert(response.msg);
              }

            })
              .catch(error => alert(error));

          })();

        }
      });
    },
    newEdition(scope) {
      /*
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          (async () => {
            var rawResponse = await fetch('https://api.salonacme.com/manager/new_edition', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                _id: this.$session.get('_id'),
                data: this.dNewEdition
              })
            });
            const content = await rawResponse.json();
            if (content.status) {
              this.newEditionSuccess = true;
              this.dNewEdition.name = content.actual_edition.name;
              this.dNewEdition.description = content.actual_edition.description;
              this.$parent.actual_edition = this.dNewEdition.name;
            }
            else { }
            // alert(content.msg);
          })();
        }
      });
      */
    },
    confirm_createEdition() {
      this.modal_confirm = {
        title: "Nueva Edición",
        text: "Al crear una nueva edición, las aplicaciones pasadas no podrán editarse y se archivarán los datos.",
        question: "¿Seguro que quieres continuar?",
        callback: "createEdition",
        status: false
      }; this.modal_confirm.status = true;
    },
    createEdition() {
      // this.modal_newEdition = true;
      this.$validator.validateAll('edition-form').then((result) => {
        if (result && this.dEdition.edition.length > 0) {
          (async () => {
            var rawResponse = await fetch('https://api.salonacme.com/manager/new_edition', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                _id: this.$session.get('_id'),
                data: this.dEdition.edition
              })
            });
            const content = await rawResponse.json();
            if (content.status) {
              /** Alert */
              this.alert_temp = {
                status: true,
                type: "success",
                // label: "Edicion creada y colocada como la actual correctamente."
                label: content.msg
              };
              setTimeout(() => { this.alert_temp.status = false; location.reload(true); }, 2000);
              /** FIN Alerta */
              // this.newEditionSuccess = true;
              // this.dNewEdition.name = content.actual_edition.name;
              // this.dNewEdition.description = content.actual_edition.description;
              // this.$parent.actual_edition = this.dNewEdition.name;
            }
            else { }
            // alert(content.msg);
          })();
        }
      });
    },
    confirms(opc) {
      switch (opc) {

        case "createEdition":
          if (this.modal_confirm.response) {
            this.createEdition();
          }
          else {
          }
          break;

        default:
          break;

      }
    }
  },
  mounted() {
    this.dConfig.name = this.$session.get('name');
    this.dConfig.email = this.$session.get('email');
    if(this.$session.get('type') == "admin"){
      this.edition_view = true;
    }
  }


}
